import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d0e9e9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 이런 사업자라면 조회 해보세요. ")
const _hoisted_2 = { class: "check" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 최근 5년간 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "세금을 납부한 적이 있는", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 사업자 ")
const _hoisted_6 = { class: "check" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "직원을 채용", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("한적이 있는 사업자 ")
const _hoisted_9 = { class: "check" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 최근 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "1년간 세금 환급을 받은적 없는", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 사업자 ")
const _hoisted_13 = { class: "check" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 절세 혜택에 대해 잘 알지 못하는 사업자 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 하나라도 해당된다면 환급금이 나올 수 있습니다.")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 무료로 조회하고 환급 받아 가세요. ")

import { ref, onMounted } from 'vue'

import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET, FONT_WEIGHT } from '@/styles/variables'

import CheckInBlueCircle from '@/styles/icon/CheckInBlueCircle.vue'

import { setAnimationObserver } from '../libs/observer'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingRecommend',
  setup(__props) {

const wrapper = ref()
const showAnimation = ref(false)

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "wrapper"
  }, [
    _createVNode(Text, {
      size: "64px",
      "line-height": "1.25",
      "mobile-size": "30px",
      weight: _unref(FONT_WEIGHT).bold,
      "word-break": "keep-all",
      "text-align": "center",
      "mobile-width": "240px",
      class: _normalizeClass(["title animation-show", { show: showAnimation.value }])
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["weight", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(["check-list animation-show delay", { show: showAnimation.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CheckInBlueCircle, {
          size: 48,
          "mobile-size": 20
        }),
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "16px"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(CheckInBlueCircle, {
          size: 48,
          "mobile-size": 20
        }),
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "16px"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CheckInBlueCircle, {
          size: 48,
          "mobile-size": 20
        }),
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "16px"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(CheckInBlueCircle, {
          size: 48,
          "mobile-size": 20
        }),
        _createVNode(Text, {
          size: "32px",
          "mobile-size": "16px"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ], 2),
    _createVNode(Text, {
      size: "24px",
      "mobile-size": "12px",
      color: _unref(COLOR_SET).blue01,
      "text-align": "center",
      class: _normalizeClass(["animation-show delay", { show: showAnimation.value }])
    }, {
      default: _withCtx(() => [
        _hoisted_15,
        _hoisted_16,
        _hoisted_17
      ]),
      _: 1
    }, 8, ["color", "class"])
  ], 512))
}
}

})